import React from "react";

function Lock() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      aria-hidden="true"
      className="icon h-[1.15rem] w-[1.15rem]"
      viewBox="0 0 256 256"
    >
      <g fill="currentColor">
        <path
          d="M216 96v112a8 8 0 01-8 8H48a8 8 0 01-8-8V96a8 8 0 018-8h160a8 8 0 018 8z"
          opacity="0.2"
        ></path>
        <path d="M208 80h-32V56a48 48 0 00-96 0v24H48a16 16 0 00-16 16v112a16 16 0 0016 16h160a16 16 0 0016-16V96a16 16 0 00-16-16zM96 56a32 32 0 0164 0v24H96zm112 152H48V96h160v112zm-68-56a12 12 0 11-12-12 12 12 0 0112 12z"></path>
      </g>
    </svg>
  );
}

export default Lock;
